import actions from './actions.js';

export default {
  // isRegistered: false,  
  namespaced: true,
  actions,
  state: {    
    listUsers: [],
    listRoles: [],
    listStates: [
        {
          value: 'Active', 
          label: 'Active' 
        },
        {
          value: 'Inactive', 
          label: 'Inactive' 
        }
    ],
    infoUser: {
        name: '',
        lastname: '',
        image: null,
        email: '',
        companyID: '',
        status: '',
        rol: {
            label: '',
            value: ''
        }
    },
    fileImage: null,
    state: 1

},  
getters: {
    _listUsers : state => {
        return state.listUsers.filter( user => {
            if(state.state === 1) return user.status === 'Active';
            if(state.state === 2) return user.status === 'Inactive';
            if(state.state === 3) return user.status === 'Disabled';
            return true;
        })
    }
},
mutations: {
    LIST_USERS: (state, listUsers) => state.listUsers = listUsers,
    LISTA_ROLES: (state, listRoles) => state.listRoles = listRoles,
    LOAD_IMAGE: (state, image) => state.infoUser.image = image,
    UPLOAD_IMAGE: (state, image) => state.fileImage = image,
    INFO_USER: (state, user) => { 
        state.infoUser = {
            username: user.username,
            name: user.name,
            image: user.picture,
            lastname: user.lastname,
            email: user.email,
            companyID: user.companyID,
            status: user.status,
            rol: {
                label: user.roleName,
                value: user.roleID
            }
        }
    },
    CHANGE_STATE: (state, payload) => state.state = payload,
}
};
